/* eslint max-classes-per-file: 0 */
import { Enums } from '@bode-canada/core';
import { Locale } from '../enums';

export const Weekdays = {
  Monday: Enums.DaysOfWeekEnum.MONDAY,
  Tuesday: Enums.DaysOfWeekEnum.TUESDAY,
  Wednesday: Enums.DaysOfWeekEnum.WEDNESDAY,
  Thursday: Enums.DaysOfWeekEnum.THURSDAY,
  Friday: Enums.DaysOfWeekEnum.FRIDAY,
  Saturday: Enums.DaysOfWeekEnum.SATURDAY,
  Sunday: Enums.DaysOfWeekEnum.SUNDAY,
};

export const WEEKDAY_INDEXES = {
  [Weekdays.Sunday]: 0,
  [Weekdays.Monday]: 1,
  [Weekdays.Tuesday]: 2,
  [Weekdays.Wednesday]: 3,
  [Weekdays.Thursday]: 4,
  [Weekdays.Friday]: 5,
  [Weekdays.Saturday]: 6,
};

export const CommonFormats = {
  TwoDigit: '2-digit',
  Numeric: 'numeric',
};

export const CommonTextFormats = {
  Narrow: 'narrow',
  Short: 'short',
  Long: 'long',
};

export const YearFormats = {
  ...CommonFormats,
};

export const MonthFormats = {
  ...CommonFormats,
  ...CommonTextFormats,
};

export const DayFormats = {
  ...CommonFormats,
};

export const HourFormats = {
  ...CommonFormats,
};

export const MinuteFormats = {
  ...CommonFormats,
};

export const SecondFormats = {
  ...CommonFormats,
};

export const WeekdayFormats = {
  ...CommonTextFormats,
};

const DateUnit = {
  Year: 'year',
  Month: 'month',
  Day: 'day',
  Weekday: 'weekday',
  Hour: 'hour',
  Minute: 'minute',
  Second: 'second',
};

export class DateOptionsBuilder {
  constructor() {
    this.options = {};
  }

  addYearFormat(format) {
    return this.#addFormatToDateUnit(format, DateUnit.Year);
  }

  addMonthFormat(format) {
    return this.#addFormatToDateUnit(format, DateUnit.Month);
  }

  addDayFormat(format) {
    return this.#addFormatToDateUnit(format, DateUnit.Day);
  }

  addHourFormat(format) {
    return this.#addFormatToDateUnit(format, DateUnit.Hour);
  }

  addMinuteFormat(format) {
    return this.#addFormatToDateUnit(format, DateUnit.Minute);
  }

  addSecondFormat(format) {
    return this.#addFormatToDateUnit(format, DateUnit.Second);
  }

  addWeekdayFormat(format) {
    return this.#addFormatToDateUnit(format, DateUnit.Weekday);
  }

  build() {
    return { ...this.options };
  }

  #addFormatToDateUnit(format, field) {
    this.options[field] = format;

    return this;
  }
}

export class DateFormatHelper {
  static format(date, options) {
    return new Intl.DateTimeFormat(Locale.EnCA, options).format(new Date(date));
  }

  static getTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
